import React from "react";
import { DocumentField, resolveAppType } from "./AtsFields";
import { useGetOne, useRecordContext } from "react-admin";
import BankIcon from '@mui/icons-material/AccountBalance';
import { PayVerticalTile } from "../../Molecules/PayVerticalTile/PayVerticalTile";


type IncomeBankingFieldProps = {
  filterValues: any;
  source?: string;
  label?: string;
  viewerRole?: string;
  applicationStatus?: string;
};

function LinkedIndicator() {
  return (
    <div
      title="Linked"
      className="d-flex flex-column align-items-center text-success"
      style={{
        padding: "0 10px",
        marginLeft: "5px",
        display: "inline-flex",
        verticalAlign: "middle",
      }}
    >
      <p style={{ padding: "0 10px", marginBottom: 0, lineHeight: 1 }}>
        <span style={{ lineHeight: 0, display: "inline-flex" }}>
          <BankIcon style={{ width: 20, height: 20, color: "currentColor" }} />
        </span>
      </p>
      <span
        style={{
          transform: "translateY(0.5px)",  // This didn't quite line up with the other text, so just nudge it here.
        }}
      >
        Linked
      </span>
    </div>
  );
}

export const IncomeBankingField: React.FC<IncomeBankingFieldProps> = ({
  filterValues,
  source = "IncomeBanking",
  label = "Income",
  viewerRole,
  applicationStatus,
}) => {
  const record = useRecordContext();
  const { data: validationCheckForPlaidBankIncome } = useGetOne("plaid/bankIncomeValidationCheck", { id: record?.Trnid }, { enabled: record?.Trnid != null, refetchOnWindowFocus: true });
  const { data: validationCheckForArgyleBankIncome } = useGetOne("argyleBankIncomeValidationCheck", { id: record?.Trnid }, { enabled: record?.Trnid != null, refetchOnWindowFocus: true });

  const resolvedType = resolveAppType(undefined, filterValues);
  const hasPlaidBanks = Array.isArray(validationCheckForPlaidBankIncome?.banks) && validationCheckForPlaidBankIncome.banks.length > 0;
  const hasArgyleBanks = Array.isArray(validationCheckForArgyleBankIncome?.banks) && validationCheckForArgyleBankIncome.banks.length > 0;
  const hasBanks = hasPlaidBanks || hasArgyleBanks;
  const plaidAvgMonthly = Number(validationCheckForPlaidBankIncome?.avgMonthlyIncome) || 0;
  const argyleAvgMonthly = Number(validationCheckForArgyleBankIncome?.avgMonthlyIncome) || 0;
  const combinedAvgMonthlyIncome = plaidAvgMonthly + argyleAvgMonthly;
  if (resolvedType === "3") return null;

  return (
    <div>
      {hasBanks && <LinkedIndicator />}
      <DocumentField
        label={label}
        source={source}
        filterValues={filterValues}
        presentKey="IncomeDeposits"
        requiredKey="IsRequiredIncomeBanking"
        newTagKey="NewTagBankIncome"
        socrStatusKey="IncomeBankingSOCRStatus"
        documentType="Linking"
        hideOnGuestCard
        viewerRole={viewerRole}
        applicationStatus={applicationStatus}
        afterStatusWhenInfoPresent={() => (
          <div style={{ marginTop: '2.5px' }}>
            {/* Putting an invisible one here for spacing, plus the adjustment above. */}
            <div aria-hidden="true" style={{ visibility: "hidden", pointerEvents: "none" }}>
              <PayVerticalTile label="Gross (Bank)" totalPay={0} />
            </div>
            <PayVerticalTile
              label="Net (Bank)"
              totalPay={combinedAvgMonthlyIncome}
            />
          </div>
        )}
      />
    </div>
  );
};

export default IncomeBankingField;
